/**
 * @whatItDoes This service deals with customer service notation on UZURV domain objects
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize, Serialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerServiceNote, CustomerServiceNoteDetail } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class CustomerServiceNoteService extends UzurvRestService {
  readonly resourceUrl = 'customerServiceNotes/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Gets a list of notes associated with a particular object in the system, using the ID and name
   *
   * @param id
   * @param name
   * @permission customer_service_note_read
   */
  getCustomerServiceNotesForObjectIdAndName(
    id: number,
    name: string,
    pageNumber?: number,
    pageSize?: number
  ): Observable<Array<CustomerServiceNoteDetail>> {
    return this.get(this.resourceUrl, { objectName: name, objectId: id, pageNumber: pageNumber, pageSize: pageSize }).pipe(
      map(response => Deserialize(response, CustomerServiceNoteDetail))
    );
  }

  /**
   * Creates a new note from a given CustomerServiceNote object
   *
   * @param customerServiceNote
   * @permission customer_service_note_create
   */
  createCustomerServiceNote(customerServiceNote: CustomerServiceNote): Observable<CustomerServiceNote> {
    return this.post(this.resourceUrl, Serialize(customerServiceNote)).pipe(map(response => Deserialize(response, CustomerServiceNote)));
  }
}
